import { ComponentType } from 'react';

import { Role } from '../../../../types/Role';
import { translate } from '../../helpers/translate.helper';

import { AgentSearch } from './AgentSearch';
import { Create } from './Create';
import { CustomerGroupSearch } from './CustomerGroupSearch';
import { GroupContextAction } from './GroupContextAction';
import { NavigateTo } from './NavigateTo';
import { OfferSearch } from './OfferSearch';
import { OrderSearch } from './OrderSearch';
import { PortSearch } from './PortSearch';
import { ProductSearch } from './ProductSearch';
import { SupplierGroupSearch } from './SupplierGroupSearch';
import { UserSearch } from './UserSearch';
import { VesselSearch } from './VesselSearch';

export const CommandListNestedRouterPathEnum = {
    ORDER: 'order',
    OFFER: 'offer',
    VESSEL: 'vessel',
    CUSTOMER: 'customer',
    SUPPLIER: 'supplier',
    AGENT: 'agent',
    PORT: 'port',
    USER: 'user',
    PRODUCT: 'product',
    CREATE: 'create',
    CONTEXT: 'context',
    NAVIGATE: 'navigate',
} as const;

export const CommandListRouterTypeEnum = {
    NESTED: 'nested',
} as const;

export type CommandListNestedRouterPath =
    (typeof CommandListNestedRouterPathEnum)[keyof typeof CommandListNestedRouterPathEnum];
type CommandListRouterType = (typeof CommandListRouterTypeEnum)[keyof typeof CommandListRouterTypeEnum];

interface RouteConfig {
    type: CommandListRouterType;
    path: CommandListNestedRouterPath;
    component: ComponentType;
    label?: string;
    enabledForRole?: (role: Role) => boolean;
}

export const commandRoutes: RouteConfig[] = [
    {
        type: CommandListRouterTypeEnum.NESTED,
        path: CommandListNestedRouterPathEnum.CONTEXT,
        component: GroupContextAction,
        label: translate('navigation.selectGroupContext'),
        enabledForRole: (role: Role) => role.isSuperAdmin(),
    },
    {
        type: CommandListRouterTypeEnum.NESTED,
        path: CommandListNestedRouterPathEnum.NAVIGATE,
        component: NavigateTo,
        label: translate('shortcutMenu.navigateTo'),
    },
    {
        type: CommandListRouterTypeEnum.NESTED,
        path: CommandListNestedRouterPathEnum.CREATE,
        component: Create,
        label: translate('shortcutMenu.create'),
        enabledForRole: (role: Role) => role.isSuperAdmin(),
    },
    {
        type: CommandListRouterTypeEnum.NESTED,
        path: CommandListNestedRouterPathEnum.ORDER,
        component: OrderSearch,
        label: translate('shortcutMenu.order'),
        enabledForRole: (role: Role) => role.isSuperAdmin() || role.isCustomer(),
    },
    {
        type: CommandListRouterTypeEnum.NESTED,
        path: CommandListNestedRouterPathEnum.OFFER,
        component: OfferSearch,
        label: translate('shortcutMenu.offer'),
        enabledForRole: (role: Role) => role.isSuperAdmin(),
    },
    {
        type: CommandListRouterTypeEnum.NESTED,
        path: CommandListNestedRouterPathEnum.VESSEL,
        component: VesselSearch,
        label: translate('shortcutMenu.vessel'),
        enabledForRole: (role: Role) => role.isSuperAdmin() || role.isCustomer(),
    },
    {
        type: CommandListRouterTypeEnum.NESTED,
        path: CommandListNestedRouterPathEnum.CUSTOMER,
        component: CustomerGroupSearch,
        label: translate('shortcutMenu.customer'),
        enabledForRole: (role: Role) => role.isSuperAdmin(),
    },
    {
        type: CommandListRouterTypeEnum.NESTED,
        path: CommandListNestedRouterPathEnum.SUPPLIER,
        component: SupplierGroupSearch,
        label: translate('shortcutMenu.supplier'),
        enabledForRole: (role: Role) => role.isSuperAdmin(),
    },
    {
        type: CommandListRouterTypeEnum.NESTED,
        path: CommandListNestedRouterPathEnum.AGENT,
        component: AgentSearch,
        label: translate('shortcutMenu.agent'),
        enabledForRole: (role: Role) => role.isSuperAdmin(),
    },
    {
        type: CommandListRouterTypeEnum.NESTED,
        path: CommandListNestedRouterPathEnum.PORT,
        component: PortSearch,
        label: translate('shortcutMenu.port'),
        enabledForRole: (role: Role) => role.isSuperAdmin(),
    },
    {
        type: CommandListRouterTypeEnum.NESTED,
        path: CommandListNestedRouterPathEnum.USER,
        component: UserSearch,
        label: translate('shortcutMenu.user'),
        enabledForRole: (role: Role) => role.isSuperAdmin(),
    },
    {
        type: CommandListRouterTypeEnum.NESTED,
        path: CommandListNestedRouterPathEnum.PRODUCT,
        component: ProductSearch,
        label: translate('shortcutMenu.product'),
        enabledForRole: (role: Role) => role.isSuperAdmin(),
    },
];
